// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { components } from '@peachjar/components';
import { get } from 'lodash';
import { parse } from 'qs';

import { css } from 'react-emotion';
import type { Location } from 'react-router-dom';
import config from '../../../../../../config';

import RegistrationFetchingQuery from './RegistrationFetchingQuery';

const SCHOOL_SETUP_URL = '/onboarding/setup/school';

const { ModalConsumer } = components;

const styles = {
  paymentContainer: css({
    height: '100%',
    width: '100%',
    backgroundColor: 'white',
  }),
};

type Props = {|
  +location: Location,
|};

type State = {
  registrantId: string,
  whichAccordionIsOpen: number,
  isPaymentAssigneePresent: boolean,
  didWriteRegistrationIdToRedux: boolean,
  agreementAssigneeName: string,
  paymentAssigneeName: string,
  registrationId: string,
};

export class PaymentContainer extends Component<Props, State> {
  constructor() {
    super();

    this.state = {
      registrantId: -1,
      whichAccordionIsOpen: -1,
      isPaymentAssigneePresent: false,
      didWriteRegistrationIdToRedux: false,
      agreementAssigneeName: '',
      paymentAssigneeName: '',
      registrationId: '',
    };

    this.openAccordion = this.openAccordion.bind(this);
  }

  async componentWillMount() {
    try {
      const { location, history } = this.props;

      if (location) {
        const queryParams = parse(location.search, { ignoreQueryPrefix: true });
        // token is a uuid of the user's email address
        const {
          token,
          registrationId = '',
          paymentAssigneeName = '',
          agreementAssigneeName = '',
          event,
        } = queryParams;

        if (registrationId && paymentAssigneeName) {
          // we know that the person visiting the page is someone who was assigned payment
          await this.setState({
            registrationId,
            paymentAssigneeName,
            isPaymentAssigneePresent: true,
          });
        } else if (registrationId && agreementAssigneeName) {
          // we know that the person visiting the page is someone who was assigned payment
          await this.setState({
            event,
            registrationId,
            agreementAssigneeName,
            isAgreementAssigneePresent: true,
          });
        } else if (registrationId) {
          await this.setState({ registrationId });
        } else if (token) {
          // the registrant is accessing the page, set their id and fetch reg info with user Id
          const identityResponse = await this.loginWithMagicLinkToken(token);
          const identity = await identityResponse.json();

          if (get(identity, 'data.id')) {
            await this.setState({
              registrantId: identity.data.id,
              token,
            });
          } else {
            history.push('/verify/expired');
          }
        } else if (this.props.registrationId) {
          // if registrationId is in redux store already
          await this.setState({
            registrationId: this.props.registrationId,
          });
        }
      }
    } catch (err) {
      console.log(err, 'ERROR getting magic link');
    }
  }

  handleState = (key, state) => {
    this.setState({
      [key]: state,
    });
  };

  handleContinue = () => {
    this.props.history.push(SCHOOL_SETUP_URL);
  };

  loginWithMagicLinkToken(token) {
    return fetch(`${config.REACT_APP_API_BASE_URL}/auth/magic-link/login/${token}`);
  }

  openAccordion(idNumber) {
    if (this.state.whichAccordionIsOpen !== idNumber) {
      this.setState({
        whichAccordionIsOpen: idNumber,
      });
    }
  }

  render() {
    // registrationId from query params
    const {
      registrationId: id,
      registrantId: userId,
      paymentAssigneeName,
      isPaymentAssigneePresent,
      isAgreementAssigneePresent,
      didWriteRegistrationIdToRedux,
      whichAccordionIsOpen,
      token,
      event,
    } = this.state;

    const variables = id ? { id } : { userId };
    return (
      <ModalConsumer>
        {({ showModal, closeModal }) => (
          <div className={`layout-column flex-auto ${styles.paymentContainer}`}>
            <RegistrationFetchingQuery
              id={id}
              registrationVariables={variables}
              didWriteRegistrationIdToRedux={didWriteRegistrationIdToRedux}
              paymentAssigneeName={paymentAssigneeName}
              isPaymentAssigneePresent={isPaymentAssigneePresent}
              isAgreementAssigneePresent={isAgreementAssigneePresent}
              event={event}
              token={token}
              showModal={showModal}
              closeModal={closeModal}
              openAccordion={this.openAccordion}
              handleContinue={this.handleContinue}
              handleState={this.handleState}
              whichAccordionIsOpen={whichAccordionIsOpen}
            />
          </div>
        )}
      </ModalConsumer>
    );
  }
}

const mapStateToProps = state => {
  return {
    registrationId: state.user.registrationId,
  };
};

export default connect(mapStateToProps)(PaymentContainer);



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/Payment/containers/PaymentContainer.jsx